// removed by extract-text-webpack-plugin
module.exports = {"psqr-wrap":"psqr-wrap___2ovVs","psqr-flex":"psqr-flex___1FnFH center___2iqBf","name-logo":"name-logo___FuqyQ","cell-name-logo":"cell-name-logo___3_afU center___2iqBf","psqr-cell":"psqr-cell___31Qhb","psqr-label":"psqr-label___1G6Pl","psqr-yes-value":"psqr-yes-value___apBW9","psqr-no-value":"psqr-no-value___2XSPj","psqr-yes-value-small":"psqr-yes-value-small___3inCy","psqr-num-value":"psqr-num-value___1jRj-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardQuickResults/PlanScorecardQuickResults.css
// module id = 907
// module chunks = 0